import { useEffect } from "react";
import { loadSiteSettings, applyAccent } from "@/lib/siteConfig";

// Applica il colore accento (oro) salvato dall'admin appena il sito si carica.
export default function ThemeApplier() {
  useEffect(() => {
    loadSiteSettings().then((s) => applyAccent(s.theme?.accent));
  }, []);
  return null;
}
